<template>
  <div>
    <wc-data-box
      :mini='mini'
      :title='title'
      :titleIcon='$store.state.icons.modules.clients.icon'
      :titleIconColor='$store.state.icons.modules.clients.color'
      showHelp
      helpText='To change these contacts, please navigate to the Contacts tab on the Project.'
    >
      <v-simple-table dense>
        <tbody>
          <tr>
            <td :class='label'>Owner</td>
            <td :class='dataValue'>
              <span v-if='project.owner'>
                {{ project.owner_obj.name_display }}
                <v-btn icon small @click="contactCard(project.owner_obj, 'Owner')">
                  <v-icon color='grey'>{{ contactIcon }}</v-icon>
                </v-btn>
              </span>
              <span v-else class='grey--text'>None</span>
            </td>
          </tr>
          <tr>
            <td :class='label'>Billing Contact</td>
            <td :class='dataValue'>
              <span v-if='project.bill_to'>
                {{ project.bill_to_obj.name_display }}
                <v-btn icon small @click="contactCard(project.bill_to_obj, 'Billing Contact')">
                  <v-icon color='grey'>{{ contactIcon }}</v-icon>
                </v-btn>
              </span>
              <span v-else class='grey--text'>None</span>
            </td>
          </tr>
          <tr>
            <td :class='label'>Sales Contact</td>
            <td :class='dataValue'>
              <span v-if='project.sales_contact'>
                {{ project.sales_contact_obj.name_display }}
                <v-btn icon small @click="contactCard(project.sales_contact_obj, 'Sales Contact')">
                  <v-icon color='grey'>{{ contactIcon }}</v-icon>
                </v-btn>
              </span>
              <span v-else class='grey--text'>None</span>
            </td>
          </tr>
          <tr>
            <td :class='label'>Notices Contact</td>
            <td :class='dataValue'>
              <span v-if='project.notices_contact'>
                {{ project.notices_contact_obj.name_display }}
                <v-btn icon small @click="contactCard(project.notices_contact_obj, 'Notices Contact')">
                  <v-icon color='grey'>{{ contactIcon }}</v-icon>
                </v-btn>
              </span>
              <span v-else class='grey--text'>None</span>
            </td>
          </tr>
          <tr>
            <td :class='label'>Install Contact</td>
            <td :class='dataValue'>
              <span v-if='project.install_contact'>
                {{ project.install_contact_obj.name_display }}
                <v-btn icon small @click="contactCard(project.install_contact_obj, 'Install Contact')">
                  <v-icon color='grey'>{{ contactIcon }}</v-icon>
                </v-btn>
              </span>
              <span v-else class='grey--text'>None</span>
            </td>
          </tr>
          <tr>
            <td :class='label'>Primary Service Contact</td>
            <td :class='dataValue'>
              <span v-if='project.site_contact'>
                {{ project.site_contact_obj.name_display }}
                <v-btn icon small @click="contactCard(project.site_contact_obj, 'Primary Service Contact')">
                  <v-icon color='grey'>{{ contactIcon }}</v-icon>
                </v-btn>
              </span>
              <span v-else class='grey--text'>None</span>
            </td>
          </tr>
          <tr>
            <td :class='label'>Second Service Contact</td>
            <td :class='dataValue'>
              <span v-if='project.secondary_site_contact'>
                {{ project.secondary_site_contact_obj.name_display }}
                <v-btn icon small @click="contactCard(project.secondary_site_contact_obj, 'Secondary Service Contact')">
                  <v-icon color='grey'>{{ contactIcon }}</v-icon>
                </v-btn>
              </span>
              <span v-else class='grey--text'>None</span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showCard'
      title='Contact'
      :icon='contactIcon'
      hideCancel
      saveText='Close'
      @save='closeCard'
      width='350'
    >
      <template v-slot:dialog-form>
        <br>
        <v-card-text>
          <h2>
            {{ contact.name_display }}<br>
            <small class='grey--text'>{{ contact.contact_type }}</small>
          </h2>
          <br>
          <address>
            {{ contact.address }}<br>
            {{ contact.city }} {{ contact.province }}<br>
            {{ contact.country }}
          </address>
        </v-card-text>
        <v-divider></v-divider>
        <v-simple-table dense>
          <tbody>
            <tr><td :class='label'>Email</td><td :class='dataValue'>{{ contact.email }}</td></tr>
            <tr><td :class='label'>Home</td><td :class='dataValue'>{{ contact.home_phone }}</td></tr>
            <tr><td :class='label'>Cell</td><td :class='dataValue'>{{ contact.cell_phone }}</td></tr>
            <tr><td :class='label'>Work</td><td :class='dataValue'>
              {{ contact.work_phone }}
              <span v-if='contact.work_phone_extension'>{{"Ext: " + contact.work_phone_extension}}</span>
            </td></tr>
          </tbody>
        </v-simple-table>
        <v-divider></v-divider>
      </template>
      <template v-slot:dialog-actions >
        <v-btn text small color='info' v-if='!contact.is_new_homeowner' :to="{ name: 'ClientOverview', params: { id: contact.id } }">
          Open Record
        </v-btn>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'old-irrigation-contacts',
  props: {
    project: {
      required: true
    },
    mini: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: vm => ({
    isLoading: false,
    showCard: false,
    contactIcon: 'mdi-account-circle',
    openInNewIcon: 'mdi-open-in-new',
    title: 'Contacts',
    label: 'grey--text',
    dataValue: 'text-right pr-2',
    contact: [],
    options: [
      { 'key': 'o', 'value': vm.project.owner_obj },
      { 'key': 'i', 'value': vm.project.install_contact_obj },
      { 'key': 'p', 'value': vm.project.site_contact_obj },
      { 'key': 's', 'value': vm.project.secondary_site_contact_obj }
    ]
  }),
  methods: {
    contactCard (cont, contType) {
      this.contact = _.cloneDeep(cont)
      this.contact.contact_type = contType
      this.showCard = true
    },
    closeCard () {
      this.showCard = false
    }
  }
}
</script>
